
  <h2>
    {{'closeAndReturnToManageCC'|translate}}
  </h2>